import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button, Col, FormGroup, Input, Row } from 'reactstrap'
import { fetchCourses } from 'store/Course/actions'
import {
  fetchTrainings,
  fetchTrainingGroups,
  fetchRoles,
  fetchUserTrainings,
  fetchGroups,
} from 'store/Group/actions'
import { fetchStores as fetchAllStores } from 'store/Stores/actions'
import {
  toggleArchived,
  toggleSecondAccess,
  selectGroup,
  fetchUsers,
  saveUser,
  fetchStores,
  onChangeUser,
  selectRole,
  selectCourse,
  toggleLockUserData,
  toggleFeedIgnore,
  selectSecondAccessStore,
  fetchArchivedUsers,
  fetchUser,
  selectLocation,
  selectStore,
} from 'store/Users/actions'
import Select, { CreatableSelect } from '../Select'
import './styles/UsersManagement.css'
import ImportUser from './ImportUser'
import { resetUser } from 'store/Users/actions'
import { sendWelcomeEmail } from 'store/Users/actions'
import { useLocation } from 'react-router-dom'
import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useHistory } from 'react-router-dom'
import { toggleShowInManagerReport } from 'store/Users/actions'
import countries from '../Login/countries.json'

const employmentStatusOptions = [
  { name: 'Active', value: '1' },
  { name: 'Terminated', value: '2' },
  { name: 'Leave of Absence', value: '3' },
]

const UserForm = (props) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const groups = useSelector((state) => state.groups)
  const stores = useSelector((state) => state.stores)
  const courses = useSelector((state) => state.courses)
  const users = useSelector((state) => state.users)
  const user = useSelector((state) => state.auth.user)

  const languageRedux = useSelector((state) => state.language?.language?.data)

  const language = languageRedux || {}

  const [accessLevelOptions, setAccessLevelOptions] = useState([])

  useEffect(() => {
    const updatedOptions = []

    if (user.access === 1) {
      updatedOptions.push({
        name: language.settings ? language.settings.admin : 'Admin',
        value: '1',
      })
    }
    if ([1, 2, 4, 5].includes(user.access)) {
      updatedOptions.push({
        name: language.settings
          ? language.settings.course_manager
          : 'Course Manager',
        value: '2',
      })
    }
    updatedOptions.push({
      name: language.settings ? language.settings.employee : 'Employee',
      value: '3',
    })
    if (user.access === 1) {
      updatedOptions.push({
        name: language.settings ? language.settings.area_admin : 'Area Admin',
        value: '4',
      })
    }
    if (user.access === 1) {
      updatedOptions.push({ name: 'Region Manager', value: '5' })
    }

    setAccessLevelOptions(updatedOptions)
  }, [user.access])

  const [accessLevel, setAccessLevel] = useState({
    name: 'Team Member',
    value: '3',
  })

  const [employmentStatus, setEmploymentStatus] = useState({
    name: 'Active',
    value: '1',
  })

  const location = useLocation()
  const search = location.search.slice(1)

  const backPath =
    search === 'emp_report'
      ? `/manager-reports/employee/${props.id}`
      : '/settings/users'

  const today = moment().format('YYYY-MM-DD')
  const birthdate = users.user.birthdate
    ? moment(users.user.birthdate).format('YYYY-MM-DD')
    : null
  const lastHireDate = users.user.lastHireDate
    ? moment(users.user.lastHireDate).format('YYYY-MM-DD')
    : null

  const useraccess = Number(users.user.access)

  const employeeRoles =
    (useraccess === 3 || useraccess === 2) && !users?.user?.roles?.length

  useEffect(() => {
    dispatch(fetchAllStores())
    dispatch(fetchStores())
    dispatch(fetchRoles())
    dispatch(fetchGroups())
    dispatch(fetchTrainings())
    dispatch(fetchTrainingGroups())
    dispatch(fetchUserTrainings())
    dispatch(fetchArchivedUsers())
    dispatch(fetchUsers())
    dispatch(fetchCourses())

    if (props.pathname !== 'new') {
      dispatch(fetchUser(props.id))
    }

    return () => {
      dispatch(resetUser())
    }
  }, [props.pathname, props.id, dispatch])

  useEffect(() => {
    setAccessLevel(
      accessLevelOptions.find(
        (accessLevel) => +accessLevel.value === +users.user.access
      )
    )
  }, [users.user.access, accessLevelOptions])

  useEffect(() => {
    setEmploymentStatus(
      employmentStatusOptions.find(
        (status) => +status.value === +users.user.status
      )
    )
  }, [users.user.status])

  return (
    <Col>
      <Row className='px-0 '>
        <Col className='px-0' xl='6' lg='6' sm='12' md='6'>
          <FormGroup className='ml-0'>
            <label
              className='form-control-label'
              htmlFor='exampleFormControlInput1'
            >
              First Name:
            </label>
            <Input
              id='exampleFormControlInput1'
              name='first_name'
              placeholder='First name'
              type='text'
              style={{ height: '38px' }}
              value={users.user.first_name || ''}
              onChange={(e) => dispatch(onChangeUser(e))}
            />
          </FormGroup>
          <FormGroup className='ml-0'>
            <label
              className='form-control-label'
              htmlFor='exampleFormControlInput1'
            >
              Last Name:
            </label>
            <Input
              id='exampleFormControlInput1'
              name='last_name'
              placeholder='Last name'
              type='text'
              style={{ height: '37px' }}
              value={users.user.last_name || ''}
              onChange={(e) => dispatch(onChangeUser(e))}
            />
          </FormGroup>
          {user.access === '5' && (
            <FormGroup className='ml-0'>
              <label
                className='form-control-label'
                htmlFor='exampleFormControlSelect1'
              >
                Location Group Access
              </label>

              <Select
                options={
                  groups &&
                  groups.groups.length > 0 &&
                  groups.groups.filter((item) => item.type === 'location')
                }
                selectedOptions={users.user.location}
                onChange={(e) => dispatch(selectLocation(e))}
                multi='true'
              />
            </FormGroup>
          )}
          {props.pathname?.indexOf('/new') !== -1 || user.status === '1' ? (
            <FormGroup className='ml-0'>
              <label
                className='form-control-label'
                htmlFor='manageableTrainings'
              >
                Course Groups (Admin only):
              </label>
              <Select
                id='manageableTrainings'
                options={
                  groups &&
                  groups.manageableTrainings.filter(
                    (item) => item.type === 'course' && item.assignable === 1
                  )
                }
                selectedOptions={users.user.groups.filter(
                  (item) => item.type === 'course'
                )}
                onChange={(e) => dispatch(selectGroup(e))}
                // placeholder='Select User Groups'
                multi='true'
              />
            </FormGroup>
          ) : null}
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='accessLevel'>
              Access Level:
            </label>
            {/* <Select
                      value={users.user.access || ""}
                      onChange={(e) => dispatch(onChangeUser(e))}
                    /> */}
            <Select
              options={accessLevelOptions}
              onChange={(e) => {
                setAccessLevel(e.option)
                dispatch(
                  onChangeUser({
                    ...e,
                    target: { name: 'access', value: e.option.value },
                  })
                )
              }}
              placeholder={accessLevel?.name}
              selectedOption={accessLevel}
            />
            {/* <Input
              name='access'
              value={users.user.access || ''}
              onChange={(e) => dispatch(onChangeUser(e))}
              id='accessLevel'
              style={{ height: '38px' }}
              type='select'
            >
              {user.access === 1 ? <option value='1'>Admin</option> : null}
              {[1, 2, 4, 5].includes(user.access) ? (
                <option value='2'>Team Trainer</option>
              ) : null}
              <option value='3'>Team Member</option>
              {user.access === 1 ? (
                <option value='4'>Unit Manager</option>
              ) : null}
              {user.access === 1 ? (
                <option value='5'>Region Manager</option>
              ) : null}
            </Input> */}
          </FormGroup>
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='email'>
              Email: *
            </label>
            <Input
              id='email'
              type='email'
              name='email'
              value={users.user.email || ''}
              onChange={(e) => dispatch(onChangeUser(e))}
              style={{ height: '38px' }}
            />
          </FormGroup>
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='username'>
              Username: *
            </label>
            <Input
              id='username'
              type='text'
              name='username'
              value={users.user.username || ''}
              onChange={(e) => dispatch(onChangeUser(e))}
              style={{ height: '38px' }}
            />
          </FormGroup>
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='password'>
              Password:
            </label>
            <Input
              id='password'
              autoComplete='new-password'
              name='password'
              type='password'
              value={users.user.password || ''}
              onChange={(e) => dispatch(onChangeUser(e))}
              style={{ height: '38px' }}
            />
          </FormGroup>
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='birthdate'>
              Birth Date
            </label>
            <Input
              // autoComplete="off"
              name='birthdate'
              id='birthdate'
              type='date'
              max={today}
              value={birthdate || ''}
              onChange={(e) => dispatch(onChangeUser(e))}
              style={{ height: '38px' }}
            />
          </FormGroup>
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='lastHireDate'>
              Last Hire Date
            </label>
            <Input
              name='lastHireDate'
              id='lastHireDate'
              type='date'
              max={today}
              value={lastHireDate || ''}
              onChange={(e) => dispatch(onChangeUser(e))}
              style={{ height: '38px' }}
            />
          </FormGroup>
        </Col>
        <Col xl='6' lg='6' sm='12' md='6'>
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='employeeID'>
              {language.settings
                ? language.settings.employee_id
                : 'Employee ID:'}
              *
            </label>
            <Input
              id='employeeID'
              name='code'
              type='text'
              value={users.user.code || ''}
              onChange={(e) => dispatch(onChangeUser(e))}
              style={{ height: '38px' }}
            />
          </FormGroup>
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='jobRoles'>
              Job Role(s): *
              {`${user.access === 3 || user.access === 2 ? ' *' : ' '}`}
            </label>
            <Select
              options={groups && groups.roles}
              selectedOptions={users.user.roles}
              onChange={(e) => dispatch(selectRole(e))}
              multi='true'
            />
          </FormGroup>
          <FormGroup className='ml-0'>
            <label
              className='form-control-label'
              htmlFor='exampleFormControlInput1'
            >
              Store Location(s): *
              {`${user.access === 3 || user.access === 2 ? ' *' : ' '}`}
            </label>
            {(() => {
              switch (user.access) {
                case 1:
                  return (
                    <CreatableSelect
                      options={stores && stores.stores}
                      selectedOptions={users.user.stores}
                      onChange={(e) => {
                        dispatch(selectStore(e))
                      }}
                    />
                  )
                case 4:
                case 2:
                  return (
                    <Select
                      options={stores && stores.stores}
                      selectedOptions={users.user.stores}
                      onChange={(e) => {
                        dispatch(selectStore(e))
                      }}
                      multi='true'
                    />
                  )
                default:
                  return (
                    <Select
                      options={stores && stores.stores}
                      selectedOptions={users.user.stores}
                      onChange={(e) => {
                        dispatch(selectStore(e))
                      }}
                      multi='true'
                    />
                  )
              }
            })()}
          </FormGroup>
          {user.access === 1 ? (
            <div>
              <div
                className='custom-control custom-checkbox mb-3'
                style={{ zIndex: '0' }}
              >
                <input
                  className='custom-control-input'
                  id='secondAccess'
                  onChange={() => dispatch(toggleSecondAccess())}
                  checked={users.isSecondAccess || false}
                  type='checkbox'
                />
                <label className='custom-control-label' htmlFor='secondAccess'>
                  Add Second Access
                </label>
              </div>
              {users.isSecondAccess ? (
                <div
                  className={
                    `user-manegement-form-row` + users.isSecondAccess
                      ? 'second-access-border'
                      : ''
                  }
                >
                  <div className='user-manegement-form-row'>
                    <label>Access Level: *</label>
                    <select
                      name='second_access'
                      value={users.user.second_access || ''}
                      onChange={(e) => dispatch(onChangeUser(e))}
                    >
                      <option value=''>--Select--</option>
                      {/* <option value='3'>{language.settings ? language.settings.employee : null}</option> */}
                      {[1, 2, 4, 5].includes(user.access) ? (
                        <option value='2'>Team Trainer</option>
                      ) : null}
                      {user.access === 1 ? (
                        <option value='4'>Unit Manager</option>
                      ) : null}
                    </select>
                  </div>
                  <label>
                    Location(s):
                    {`${
                      users.user.access === 3 || users.user.access === 2
                        ? '*'
                        : ''
                    }`}
                  </label>
                  <Select
                    options={stores.stores.filter(
                      (item) =>
                        !users.user.stores
                          .map((subitem) => subitem.id)
                          .includes(item.id)
                    )}
                    selectedOptions={users.user.secondAccessStores}
                    onChange={() => dispatch(selectSecondAccessStore())}
                    multi='true'
                  />
                </div>
              ) : null}
            </div>
          ) : null}
          {[1].includes(user.access) ? (
            <div
              className='custom-control custom-checkbox mb-3'
              style={{ zIndex: '0' }}
            >
              <input
                className='custom-control-input'
                id='archived'
                checked={users.user.isArchived || false}
                onChange={() => dispatch(toggleArchived())}
                type='checkbox'
              />
              <label className='custom-control-label' htmlFor='archived'>
                Archived
              </label>
            </div>
          ) : null}
          {user.access === 1 ? (
            <div
              className='custom-control custom-checkbox mb-3'
              style={{ zIndex: '0' }}
            >
              <input
                className='custom-control-input'
                id='userData'
                type='checkbox'
                checked={users.user.lockUserData || false}
                onChange={() => dispatch(toggleLockUserData())}
              />
              <label className='custom-control-label' htmlFor='userData'>
                Lock User Data
              </label>
            </div>
          ) : null}

          {user.access === 1 ? (
            <div
              className='custom-control custom-checkbox mb-3'
              style={{ zIndex: '0' }}
            >
              <input
                className='custom-control-input'
                id='feedIgnore'
                type='checkbox'
                checked={users.user.feedIgnore || false}
                onChange={() => dispatch(toggleFeedIgnore())}
              />
              <label className='custom-control-label' htmlFor='feedIgnore'>
                Feed Ignore
              </label>
            </div>
          ) : null}

          <div
            className='custom-control custom-checkbox mb-3'
            style={{ zIndex: '0' }}
          >
            <input
              className='custom-control-input'
              id='show_manager_report'
              type='checkbox'
              checked={users.user.showInManagerReport || false}
              onChange={() => dispatch(toggleShowInManagerReport())}
            />
            <label
              className='custom-control-label'
              htmlFor='show_manager_report'
            >
              Don't show in manager's report
            </label>
          </div>

          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='userStatus'>
              Employment Status:
            </label>
            {console.log(employmentStatusOptions, employmentStatus, 'leart581')}
            <Select
              options={employmentStatusOptions}
              onChange={(e) => {
                setEmploymentStatus(e.option)
                dispatch(
                  onChangeUser({
                    ...e,
                    target: { name: 'status', value: e.option.value },
                  })
                )
              }}
              placeholder={employmentStatus?.name}
              selectedOption={employmentStatus}
            />

            {/* <Input
              name='status'
              value={users.user.status || ''}
              onChange={(e) => dispatch(onChangeUser(e))}
              id='userStatus'
              // size={'sm'}
              className='py-1'
              style={{ height: '38px' }}
              type='select'
            >
              <option value='1'>Active</option>
              <option value='2'>Terminated</option>
              <option value='3'>Leave of Absence</option>
            </Input> */}
          </FormGroup>
          <FormGroup className='ml-0 '>
            <label className='form-control-label' htmlFor='individualCourses'>
              Assign Individual courses(Admin only):
            </label>

            <Select
              options={courses.courses.length && courses.courses}
              selectedOptions={users.user.courses}
              onChange={(e) => {
                dispatch(selectCourse(e))
              }}
              multi={true}
              valueKey='id'
            />
          </FormGroup>

          {console.log(users.user.courses, 'leart628')}

          {users?.user?.country ? (
            <FormGroup className='ml-0 '>
              <label className='form-control-label' htmlFor='individualCourses'>
                Country:
              </label>

              <Select
                options={countries}
                selectedOptions={countries?.find(
                  (country) => country?.name === users?.user?.country
                )}
                // onChange={(e) => {
                //   dispatch(selectCourse(e))
                // }}
                multi={false}
                valueKey='id'
              />
            </FormGroup>
          ) : null}

          {props.pathname !== 'new' && (
            <Link to={`/manager-reports/employee/${props.id}`}>
              <SubmitModalButton
                text={`View ${
                  language.settings ? language.settings.employee : 'Employee'
                }'s Courses`}
              />
            </Link>
          )}
          {/* {props.courseConfig.enableWelcomeEmail === 1 && ( */}
          {/* {props.pathname !== 'new' && (
            <Button
              disabled={users.user.isWelcomeEmailButtonDisabled}
              onClick={() => dispatch(sendWelcomeEmail(props.id))}
              className={`btn btn-info ${
                users.user.isWelcomeEmailButtonDisabled ? 'button-disabled' : ''
              }`}
            >
              Resend Login Details
            </Button>
          )} */}
          {/* )} */}
        </Col>
      </Row>
      <hr />
      <Row className='pl-3'>
        <div className='row user-management-btn-wrapper'>
          <div className='col-md-12 px-0'>
            {(() => {
              let requiredFields =
                users.user.first_name &&
                users.user.last_name &&
                users.user.email &&
                users.user.username &&
                !employeeRoles &&
                users.user.code &&
                // validateEmail(users.user.email) &&
                // users.user.email &&
                (users.user.access === 5 ? users.user.region.length > 0 : true)
              // && existingUser == -1
              if (users.isSecondAccess) {
                requiredFields =
                  users.user.first_name &&
                  users.user.last_name &&
                  users.user.email &&
                  users.user.username &&
                  users.user.code &&
                  users.user.second_access &&
                  users.user.secondAccessStores.length
              }
              if (users.user.access === 3 || users.user.access === 2) {
                if (requiredFields) {
                  if (users.user.stores.length) {
                    return (
                      <SubmitModalButton
                        text={users.creatingLoading ? 'Saving...' : 'Save'}
                        customFn={() => dispatch(saveUser(history, backPath))}
                      />
                    )
                  } else {
                    return (
                      <SubmitModalButton
                        text={users.creatingLoading ? 'Saving...' : 'Save'}
                        customFn={() => dispatch(saveUser(history, backPath))}
                      />
                    )
                  }
                }

                return (
                  <SubmitModalButton
                    text={users.creatingLoading ? 'Saving...' : 'Save'}
                    customFn={() => dispatch(saveUser(history, backPath))}
                  />
                )
              } else {
                if (requiredFields) {
                  return (
                    <SubmitModalButton
                      text={users.creatingLoading ? 'Saving...' : 'Save'}
                      customFn={() => dispatch(saveUser(history, backPath))}
                    />
                  )
                }
                return (
                  <SubmitModalButton
                    text={users.creatingLoading ? 'Saving...' : 'Save'}
                    customFn={() => dispatch(saveUser(history, backPath))}
                  />
                )
              }
            })()}
            <Link to={backPath}>
              <CancelModalButton />
            </Link>
          </div>
        </div>
      </Row>
    </Col>
  )
}
// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  if (props.match.params.id === 'import') {
    return <ImportUser />
  } else {
    return (
      <UserForm pathname={props.match.params.id} id={props.match.params.id} />
    )
  }
}
